export default __webpack_public_path__ + "static/media/dark_3_placeholder.a0520d7b.jpg";